import type { PartnerAccount } from '@/types/api';
import { PartnerAccountCard } from './PartnerAccountCard';

interface PartnerAccountsListProps {
  accounts: PartnerAccount[];
  isLoading: boolean;
}

export function PartnerAccountsList({ accounts, isLoading }: PartnerAccountsListProps): JSX.Element {
  if (isLoading) {
    return (
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="h-48 animate-pulse rounded-lg border bg-muted"
            data-testid="partner-account-skeleton"
          />
        ))}
      </div>
    );
  }

  if (accounts.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center rounded-lg border border-dashed py-12">
        <p className="text-lg font-medium">No partner accounts connected</p>
        <p className="text-sm text-muted-foreground">
          Click "Add Partner Account" to connect your first property management platform.
        </p>
      </div>
    );
  }

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-testid="partner-accounts-list">
      {accounts.map((account) => (
        <PartnerAccountCard key={account.id} account={account} />
      ))}
    </div>
  );
}
